export default __webpack_public_path__ + "static/media/sv22_kr_jing_b3.23eb329f.mp3";